export const maskNumber = (number) => {
    if (!number || number.length < 4) return number; // Handle edge cases
    const visiblePart = number.slice(-4); // Last 4 digits
    const hiddenPart = "*".repeat(number.length - 4); // Mask the rest
    return `${hiddenPart.slice(0, hiddenPart.length - 2)} ${visiblePart.slice(0, 2)} ${visiblePart.slice(2)}`;
};